import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TextField from '@material-ui/core/TextField';
import { Calendar } from 'primereact/calendar';
import { GiftAction } from "../../actions/GiftAction.js";
import { connect } from 'react-redux';
import tableRequest from '../../models/tableRequest.js';
import { Toast } from 'primereact/toast';
import { CSVLink } from "react-csv";
import Loader from '../../templates/Loader.js';
import { Dropdown } from 'bootstrap';
// import Dropdown from 'react-bootstrap/Dropdown'; 
class Gift extends Component {
    constructor(props) {
        super(props);        
        this.tblResponse = new tableRequest();
        this.onPage = this.onPage.bind(this);
        this.onSort = this.onSort.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.FilterData = this.FilterData.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.state = {
            loading: false,
            FromDate: new Date(),
            ToDate: new Date(),
            first: 0,
            headers: [
                {
                    key: "UserName",
                    label: " User Name"
                }, {
                    key: "GroupName",
                    label: "Group Name"
                }, 
                {
                    key: "ThreesholdValue",
                    label: "Threeshold Value"
                }, 
                {
                    key: "EarnedPoints",
                    label: "Earned Points"
                }],
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            visible: false,
            sortOrder: '',
            selectedOption: "", // To track the selected dropdown option
            searchValues: {},   // To store search values for each option                   
        }
    }
    componentDidMount() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() - 7);
        this.tblResponse.FromDate = date.toLocaleDateString();
        this.tblResponse.ToDate = new Date().toLocaleDateString();
        this.setState({
            FromDate: date,
            ToDate: new Date()
        });
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.mappingList !== this.props.mappingList) {
            // this.props.myProp has a different value
            if (this.props.mappingList) {
                var e = this.props.mappingList;
                this.setState({
                    totalRecords: e[0].TotalRows
                });
            }
        }
    } 
    handleActionClick=(e)=>{
        e.preventDefault();
        this.setState((prevState)=({
            showSearch:!prevState.showSearch,
        }));
    };
    handleActionClick = (e) => {
        e.preventDefault(); // Prevent dropdown from closing
        this.setState((prevState) => ({
          showSearch: !prevState.showSearch, // Toggle the search box visibility
        }));
      };
    
      handleOptiionChange=(event)=>{ 
             
        this.tblResponse.SortColumn = event.target.value;
        //this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.tblResponse.year = selectedYear;  // Set year filter in the request
        this.tblResponse.year = this.state.selectedOption;  // Set year filter in the request
        this.props.exportingData(this.tblResponse);
        this.props.fetchApi(this.tblResponse);
        
        // this.setState({
        //     selectedOption: event.target.value,            
        // });
        this.setState({
            selectedOption: selectedYear,// Update selected option
        });
      };
      //Handle Search Input Change
      handleOptiionChange = (event) => { 
        const selectedYear = event.target.value;  // Define selectedYear correctly
        this.tblResponse.year = selectedYear;    // Set the year filter in the request
        // Call the API methods to fetch filtered data and export it
        this.props.exportingData(this.tblResponse);
        this.props.fetchApi(this.tblResponse);   
        // Update the component's state to store the selected option
        this.setState({
            selectedOption: selectedYear,  // Update the selected option state
            selectedOption: selectedYear 
            
        });
    };
    
 GetMapping() {
        let ToDt = new Date();
        let FrmDt = new Date();
        FrmDt.setDate(ToDt.getDate() - 7);
        const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
        const myToDt = this.getCurrentDateYYYYMMDD(ToDt);
        this.tblResponse.FromDate = myFmDt;
        this.tblResponse.ToDate = myToDt;
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }
    // FilterData() {       
    //     this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
    //     this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    //     this.props.exportingData(this.tblResponse);
    //     this.props.fetchApi(this.tblResponse);
    //     this.tblResponse.DealerId = this.state.selectedDealer; // Add dealer filter       
    // } 
    FilterData() {
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.props.exportingData(this.tblResponse);
        this.props.fetchApi(this.tblResponse);
    }         
    getCurrentDateYYYYMMDD(dt) {
        var dd = String(dt.getDate()).padStart(2, '0');
        var mm = String(dt.getMonth() + 1).padStart(2, '0');
        var yyyy = dt.getFullYear();

        dt = yyyy + '/' + mm + '/' + dd;
        return dt;
    }        
    handleChange(event) {
        const { name, value } = event.target;
        switch (name) {
            case 'FromDate':
                if (value === null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    // this.refs.Messchild.showError("Please select from date.");
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please select from date.', life: 3000 });
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please enter only date.', life: 3000 });
                    // this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'From date must be less than to date.', life: 3000 });
                        // this.refs.Messchild.showError("From date must be less than to date.");
                        return;
                    }
                }                
                break;
            case 'ToDate':
                if (value === null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please select to date.', life: 3000 });
                    // this.refs.Messchild.showError("Please select to date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please enter only date.', life: 3000 });
                    // this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'To date must be greater than from date.', life: 3000 });
                        // this.refs.Messchild.showError("To date must be greater than from date.");
                        return;
                    }
                }
                break;
            default:
                break;
        }
        this.setState({ [name]: value });
    }
     //to lazy load
    getLazyLoadingValues(event) {
      
        this.setState({ rows: event.rows, first: event.first });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : this.tblResponse.SearchValue ? this.tblResponse.SearchValue : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        // this.tblResponce.
    }   
    onPage(event) {
      
        this.props.loadingData(true);
        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.props.fetchApi(this.tblResponse);
            this.props.exportingData(this.tblResponse);
        }, 250);
    }        
    //to search
    searchFilter(e) {      
        const searchValue = e.target.value.toLowerCase();       
        this.setState({globalFilter:searchValue});        
        this.tblResponse.SearchValue = searchValue;
        this.props.fetchApi({...this.tblResponse,SearchValue:searchValue});
        this.props.exportingData(this.tblResponse);
        // this.setState({ globalFilter: searchValue }); 
        this.setState({globalFilter:searchValue}); 
    }
    //to sort
    onSort(event) {
      
        this.props.loadingData(true);;
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.multiSortMeta[0].field === "" ? "" : event.multiSortMeta[0].field;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';//this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }
    render() {
       const{selectedOption,searchValues}=this.state;
        return (
            <div className="datatable-filter-demo">               
                <Toast ref={(el) => this.toast = el} />
                <Loader loader={this.props.loading} />
                <div className="row mb-3">   
    <div className="col-md-3 d-flex align-items-center">
        <h4>Generated Gifts</h4>
    </div>  
    <div className="col-md-9 d-flex align-items-center justify-content-between">       
          <div>
            {/* <select 
                className="form-control p-2 ml-3" 
                style={{ height: "40px", borderRadius: "4px"}} 
                onChange={this.handleOptiionChange} 
                size="small"
            >
                <option value=" ">All Data</option>
                <option value="2024"> 2024</option>
                <option value="2025"> 2025</option>
            </select>             */}
        </div>
        {/* Export Button */}
        <div>            
        {/* <button className="btn btn-primary p-2 ml-3">
                    Genrate Gift
                </button> */}
            <CSVLink 
                data={this.props.List}  
                headers={this.state.headers}  
                filename={"Genrated Gift Report .csv"}  
                target="_blank"                                  
            > 
             <button className="btn btn-success p-2 mr-2">
                    Export
                </button>
            </CSVLink>
        </div>               
    </div>
</div>
               <div className="card">
                    <DataTable value={this.props.mappingList}
                        scrollable responsive={true}
                        globalFilter={this.state.globalFilter}
                        emptyMessage="No Data found." sortMode="multiple" paginator={true}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={this.state.rows} style={{ width: '100%' }}rowsPerPageOptions={[5, 10, 100, 200, parseInt(this.state.totalRecords)]}
                        totalRecords={this.state.totalRecords}
                        lazy={true} first={this.state.first}                                            
                        onPage={this.onPage} onSort={this.onSort} ref={(el) => { this.dt = el; }}>                      
                        <Column field="UserName" disable header="Contractor Name" sortable></Column>              
                        <Column field="GroupName" disable header="Group Name" sortable></Column>                       
                        <Column field="ThreesholdValue" disable header="Threeshold Value" sortable></Column>
                        <Column field="EarnedPoints" disable header="Earned Points" sortable></Column>              
                    </DataTable>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        mappingList: state.Gift.items,
        List: state.Gift.exportitems == undefined ? [] : state.Gift.exportitems,
        loading: state.Gift.loading   
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        fetchApi: (obj) => {
            dispatch(GiftAction.getAll(obj))
        },
        loadingData: (isLoding) => dispatch(GiftAction.loadingData(isLoding)),
        exportingData: (obj) => dispatch(GiftAction.exportData(obj)),      

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Gift);